import axios from 'axios';
import { IQuienesSomos } from '@/shared/model/quienes-somos.model';

const baseApiUrl = 'api/quienes-somos';

export default class QuienesSomosService {
  public find(): Promise<IQuienesSomos> {
    return new Promise<IQuienesSomos>((resolve, reject) => {
      axios.get(`${baseApiUrl}/1`).then(res => resolve(res.data)).catch(err => reject(err));
    });
  }

  public update(entity: IQuienesSomos): Promise<IQuienesSomos> {
    return new Promise<IQuienesSomos>((resolve, reject) => {
      axios.put(`${baseApiUrl}/1`, entity).then(res => resolve(res.data)).catch(err => reject(err));
    });
  }
}
